import CommonConst from '../../../../common/Const';
import { TABS } from '../../../../fundamental/financial-statement/Const';
import { CRITERIAS } from '../../../../market/heatmap/Const';

const { listComponent } = CommonConst;

export const quickComponents = [
  listComponent.TimeAndSales,
  listComponent.PriceDepth,
  listComponent.PriceData,
  listComponent.Charting,
];

export const tickerQuickComponents = [
  listComponent.TimeAndSales,
  listComponent.PriceDepth,
  listComponent.PriceData,
  listComponent.Charting,
  listComponent.FASnapshot,
  listComponent.ConsensusAnalysis,
  listComponent.Ownership,
  listComponent.Valuation,
];

export const components = [
  {
    component: CommonConst.listComponent.MarketInDepth,
    props: {
      tab: 1,
    },
    componentNameKey: 'marketInDepth.index',
  },
  {
    component: CommonConst.listComponent.MarketInDepth,
    props: {
      tab: 2,
    },
    componentNameKey: 'marketInDepth.prospect',
  },
  {
    component: CommonConst.listComponent.MarketInDepth,
    props: {
      tab: 3,
    },
    componentNameKey: 'marketInDepth.valuation',
  },
  {
    component: CommonConst.listComponent.MarketInDepth,
    props: {
      tab: 4,
    },
    componentNameKey: 'marketInDepth.liquidity',
  },
  {
    component: CommonConst.listComponent.MarketInDepth,
    props: {
      tab: 5,
    },
    componentNameKey: 'marketInDepth.marketAnomaly',
  },

  {
    component: CommonConst.listComponent.TopVolume,
    props: {
      tab: 1,
    },
    componentNameKey: 'topVolume.overview',
  },
  {
    component: CommonConst.listComponent.TopVolume,
    props: {
      tab: 2,
    },
    componentNameKey: 'topVolume.performance',
  },
  {
    component: CommonConst.listComponent.TopVolume,
    props: {
      tab: 3,
    },
    componentNameKey: 'topVolume.financial',
  },
  {
    component: CommonConst.listComponent.TopVolume,
    props: {
      tab: 4,
    },
    componentNameKey: 'topVolume.technical',
  },
  {
    component: CommonConst.listComponent.TopVolume,
    props: {
      tab: 5,
    },
    componentNameKey: 'topVolume.chart',
  },
  //TOP BREAKOUT
  {
    component: CommonConst.listComponent.TopBreakout,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopBreakout.overview',
  },
  {
    component: CommonConst.listComponent.TopBreakout,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopBreakout.performance',
  },
  {
    component: CommonConst.listComponent.TopBreakout,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopBreakout.financial',
  },
  {
    component: CommonConst.listComponent.TopBreakout,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopBreakout.technical',
  },
  {
    component: CommonConst.listComponent.TopBreakout,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopBreakout.chart',
  },

  //Top value
  {
    component: CommonConst.listComponent.TopValue,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopValue.overview',
  },
  {
    component: CommonConst.listComponent.TopValue,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopValue.performance',
  },
  {
    component: CommonConst.listComponent.TopValue,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopValue.financial',
  },
  {
    component: CommonConst.listComponent.TopValue,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopValue.technical',
  },
  {
    component: CommonConst.listComponent.TopValue,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopValue.chart',
  },

  //Top gainers
  {
    component: CommonConst.listComponent.TopGainers,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopGainers.overview',
  },
  {
    component: CommonConst.listComponent.TopGainers,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopGainers.performance',
  },
  {
    component: CommonConst.listComponent.TopGainers,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopGainers.financial',
  },
  {
    component: CommonConst.listComponent.TopGainers,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopGainers.technical',
  },
  {
    component: CommonConst.listComponent.TopGainers,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopGainers.chart',
  },
  //Top loser
  {
    component: CommonConst.listComponent.TopLosers,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopLosers.overview',
  },
  {
    component: CommonConst.listComponent.TopLosers,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopLosers.performance',
  },
  {
    component: CommonConst.listComponent.TopLosers,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopLosers.financial',
  },
  {
    component: CommonConst.listComponent.TopLosers,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopLosers.technical',
  },
  {
    component: CommonConst.listComponent.TopLosers,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopLosers.chart',
  },

  //Top new high
  {
    component: CommonConst.listComponent.TopNewHigh,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopNewHigh.overview',
  },
  {
    component: CommonConst.listComponent.TopNewHigh,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopNewHigh.performance',
  },
  {
    component: CommonConst.listComponent.TopNewHigh,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopNewHigh.financial',
  },
  {
    component: CommonConst.listComponent.TopNewHigh,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopNewHigh.technical',
  },
  {
    component: CommonConst.listComponent.TopNewHigh,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopNewHigh.chart',
  },
  //Top new low
  {
    component: CommonConst.listComponent.TopNewLow,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopNewLow.overview',
  },
  {
    component: CommonConst.listComponent.TopNewLow,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopNewLow.performance',
  },
  {
    component: CommonConst.listComponent.TopNewLow,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopNewLow.financial',
  },
  {
    component: CommonConst.listComponent.TopNewLow,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopNewLow.technical',
  },
  {
    component: CommonConst.listComponent.TopNewLow,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopNewLow.chart',
  },

  //Top foreign trading
  {
    component: CommonConst.listComponent.TopForeignTrade,
    props: {
      tab: 1,
    },
    componentNameKey: 'TopForeignTrade.overview',
  },
  {
    component: CommonConst.listComponent.TopForeignTrade,
    props: {
      tab: 2,
    },
    componentNameKey: 'TopForeignTrade.performance',
  },
  {
    component: CommonConst.listComponent.TopForeignTrade,
    props: {
      tab: 3,
    },
    componentNameKey: 'TopForeignTrade.financial',
  },
  {
    component: CommonConst.listComponent.TopForeignTrade,
    props: {
      tab: 4,
    },
    componentNameKey: 'TopForeignTrade.technical',
  },
  {
    component: CommonConst.listComponent.TopForeignTrade,
    props: {
      tab: 5,
    },
    componentNameKey: 'TopForeignTrade.chart',
  },

  //Heatmap
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.MARKET_CAP,
    },
    componentNameKey: 'HeatMap.marketCap',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.VOLUME,
    },
    componentNameKey: 'HeatMap.volume',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.VALUE,
    },
    componentNameKey: 'HeatMap.value',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.BUY_VOL,
    },
    componentNameKey: 'HeatMap.buyVol',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.SELL_VOL,
    },
    componentNameKey: 'HeatMap.sellVol',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.BUY_VALUE,
    },
    componentNameKey: 'HeatMap.buyVal',
  },
  {
    component: CommonConst.listComponent.HeatMap,
    props: {
      tab: CRITERIAS.SELL_VALUE,
    },
    componentNameKey: 'HeatMap.sellVal',
  },

  //Money flow
  {
    component: CommonConst.listComponent.MoneyFlow,
    props: {
      tab: 1,
    },
    componentNameKey: 'MoneyFlow.contribution',
  },
  {
    component: CommonConst.listComponent.MoneyFlow,
    props: {
      tab: 2,
    },
    componentNameKey: 'MoneyFlow.foreign',
  },
  {
    component: CommonConst.listComponent.MoneyFlow,
    props: {
      tab: 3,
    },
    componentNameKey: 'MoneyFlow.proprietary',
  },
  //Time & Sales
  {
    component: CommonConst.listComponent.TimeAndSales,
    props: {},
    componentNameKey: 'TimeAndSales.name',
  },
  //Price depth
  {
    component: CommonConst.listComponent.PriceDepth,
    props: {},
    componentNameKey: 'PriceDepth.name',
  },
  //Price data
  {
    component: CommonConst.listComponent.PriceData,
    props: {
      tab: 1,
    },
    componentNameKey: 'PriceData.overview',
  },
  {
    component: CommonConst.listComponent.PriceData,
    props: {
      tab: 2,
    },
    componentNameKey: 'PriceData.orderStatistic',
  },
  {
    component: CommonConst.listComponent.PriceData,
    props: {
      tab: 3,
    },
    componentNameKey: 'PriceData.foreign',
  },
  {
    component: CommonConst.listComponent.PriceData,
    props: {
      tab: 4,
    },
    componentNameKey: 'PriceData.proprietary',
  },

  //Charting
  {
    component: CommonConst.listComponent.Charting,
    componentNameKey: 'Charting.name',
  },

  //Ta signals
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.indicatorSignal',
    props: {
      tab: 1,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.overview',
    props: {
      tab: 2,
      subTab: 1,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.cefl',
    props: {
      tab: 2,
      subTab: 2,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.cancelled',
    props: {
      tab: 2,
      subTab: 3,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.pressing',
    props: {
      tab: 2,
      subTab: 4,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.aggressive',
    props: {
      tab: 2,
      subTab: 5,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.deceptive.closing',
    props: {
      tab: 2,
      subTab: 6,
    },
  },
  {
    component: CommonConst.listComponent.TASignals,
    componentNameKey: 'TASignals.priceVolumeAnalysis',
    props: {
      tab: 3,
    },
  },

  //News
  {
    component: CommonConst.listComponent.News,
    componentNameKey: 'News.fiintradeDiary',
    props: {
      tab: 3,
    },
  },
  {
    component: CommonConst.listComponent.News,
    componentNameKey: 'News.fiintradeCall',
    props: {
      tab: 4,
    },
  },
  {
    component: CommonConst.listComponent.News,
    componentNameKey: 'News.autoNews',
    props: {
      tab: 2,
    },
  },
  {
    component: CommonConst.listComponent.News,
    componentNameKey: 'News.newsAggregator',
    props: {
      tab: 1,
    },
  },
  //Snapshot
  {
    component: CommonConst.listComponent.FASnapshot,
    componentNameKey: 'FASnapshot.name',
    props: {},
  },

  //Ownership
  {
    component: CommonConst.listComponent.Ownership,
    componentNameKey: 'Ownership.majorShareholder',
    props: {
      tab: 1,
    },
  },
  {
    component: CommonConst.listComponent.Ownership,
    componentNameKey: 'Ownership.bod',
    props: {
      tab: 2,
    },
  },
  //Financial analysis
  {
    component: CommonConst.listComponent.FinancialAnalysis,
    componentNameKey: 'FinancialAnalysis.FACheckup',
    props: {
      tab: 1,
    },
  },
  {
    component: CommonConst.listComponent.FinancialAnalysis,
    componentNameKey: 'FinancialAnalysis.ZMFScore',
    props: {
      tab: 3,
    },
  },

  //Financial ratio
  {
    component: CommonConst.listComponent.FinancialRatio,
    componentNameKey: 'FinancialRatio.name',
  },
  // Cash dividend analysis
  {
    component: CommonConst.listComponent.FADividendAnalysis,
    componentNameKey: 'FADividendAnalysis.name',
  },
  //Consensus analysis
  {
    component: CommonConst.listComponent.ConsensusAnalysis,
    componentNameKey: 'ConsensusAnalysis.name',
  },
  //Financial statement
  {
    component: CommonConst.listComponent.FinancialStatement,
    componentNameKey: 'FinancialStatement.balanceSheet',
    props: {
      tab: TABS.BALANCE_SHEET,
    },
  },
  {
    component: CommonConst.listComponent.FinancialStatement,
    componentNameKey: 'FinancialStatement.incomeStatement',
    props: {
      tab: TABS.INCOME_STATEMENT,
    },
  },
  {
    component: CommonConst.listComponent.FinancialStatement,
    componentNameKey: 'FinancialStatement.cashFlowStatement',
    props: {
      tab: TABS.CASH_FLOW_STATEMENT,
    },
  },
  //Alert
  {
    component: CommonConst.listComponent.Alerts,
    componentNameKey: 'Alerts.name',
    props: {},
  },
  //Screener
  {
    component: CommonConst.listComponent.Screener,
    componentNameKey: 'Screener.name',
    props: {},
  },
  //Valuation
  {
    component: CommonConst.listComponent.Valuation,
    componentNameKey: 'Valuation.name',
    props: {},
  },
  //FiinTa
  {
    component: CommonConst.listComponent.TradeData,
    componentNameKey: 'TradeData.name',
    props: {},
  },
  //Ranking
  {
    component: CommonConst.listComponent.STRanking,
    componentNameKey: 'STRanking.fiintradeRanking',
    props: {
      tab: 1,
    },
  },
  {
    component: CommonConst.listComponent.STRanking,
    componentNameKey: 'STRanking.allScore',
    props: {
      tab: 2,
    },
  },
  //Strategy
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.overview',
    props: {
      tab: 1,
      subTab: 1,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.value',
    props: {
      tab: 1,
      subTab: 2,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.growth',
    props: {
      tab: 1,
      subTab: 3,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.momentum',
    props: {
      tab: 1,
      subTab: 4,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.vgm',
    props: {
      tab: 1,
      subTab: 5,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.fiintradeStrategy.leaders',
    props: {
      tab: 1,
      subTab: 6,
    },
  },

  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.canSlim',
    props: {
      tab: 2,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.taStrategy.accummulation',
    props: {
      tab: 3,
      subTab: 1,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.taStrategy.breakout',
    props: {
      tab: 3,
      subTab: 2,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.taStrategy.breakoutMA',
    props: {
      tab: 3,
      subTab: 3,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.taStrategy.bestInDowntrend',
    props: {
      tab: 3,
      subTab: 4,
    },
  },
  {
    component: CommonConst.listComponent.Strategy,
    componentNameKey: 'Strategy.taStrategy.marketAnomaly',
    props: {
      tab: 3,
      subTab: 5,
    },
  },
];
